import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-h4 ml-4"
}

import {
  AppAuthService,
  CardIssuePointsService,
  ControlQuestion,
  ControlQuestionsService,
  MunicipalEntitiesService,
  Role,
  RoleType,
  RolesService,
  UpdateUserOpts,
  User,
  UsersService,
  userGetFullname,
} from '@prodcard/core'
import { createCtx, handleError, useWatcherSavedRef, callSuccessToast } from '../../../../helpers'
import { computed, ref, watch } from 'vue'
import { helpers, required, requiredIf, sameAs } from '@vuelidate/validators'
import useVuelidate, { ErrorObject } from '@vuelidate/core'
import {
  VPasswordField,
  VCardIssuePointSelect,
  VPhoneField,
  VMunicipalEntitiesSelect,
  CardHeader,
} from '../../../../components'
import { pickBy, isEmpty } from 'lodash'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersProfilePage',
  props: {
    usersService: {},
    rolesService: {},
    controlQuestionsService: {},
    cardIssuePointsService: {},
    municipalEntitiesService: {},
    authService: {}
  },
  setup(__props: any) {

const props = __props;

const ctx = createCtx()
const router = useRouter()


const user = ref<User | undefined>()
const roles = ref<Role[]>([])
const controlQuestions = ref<ControlQuestion[]>([])
const userOpts = useWatcherSavedRef<UpdateUserOpts>('UserForm', {})
const passwordConfirmation = useWatcherSavedRef('UserFormPasswordConfirmation', '')
const loadingUser = ref(false)
const loadingRoles = ref(false)
const loadingControlQuestions = ref(false)
const loading = ref(false)

handleError(async () => {
  const currentUser = props.authService.authorizedUser.value
  if (currentUser) {
    user.value = await props.usersService.findById(ctx, currentUser.id)
    userOpts.value = {
      name: userOpts.value?.name ?? user.value?.name,
      surname: userOpts.value?.surname ?? user.value?.surname,
      patronymic: userOpts.value?.patronymic ?? user.value?.patronymic,
      phone: userOpts.value?.phone ?? user.value?.phone,
      password: userOpts.value?.password ?? '',
      controlQuestionId: userOpts.value?.controlQuestionId ?? user.value?.controlQuestionId,
      controlAnswer: userOpts.value?.controlAnswer ?? undefined,
      cardIssuePointId: userOpts.value?.cardIssuePointId ?? user.value?.cardIssuePointId,
      municipalEntityId: userOpts.value?.municipalEntityId ?? user.value?.municipalEntityId,
    }
  }
}, loadingUser)

handleError(async () => {
  const response = await props.rolesService.findAll(ctx)
  roles.value = response
}, loadingRoles)

handleError(async () => {
  const response = await props.controlQuestionsService.findAll(ctx)
  controlQuestions.value = response
}, loadingControlQuestions)

const rules = computed(() => ({
  surname: {
    required: helpers.withMessage('Фамилия не может быть пустой', required),
  },
  name: {
    required: helpers.withMessage('Имя не может быть пустым', required),
  },
  phone: {
    validator: helpers.withMessage('Контактный телефон некорректен', () => {
      if (!userOpts.value.phone) return true

      return userOpts.value.phone.length === 11
    }),
  },
  password: {
    sameAs: helpers.withMessage('Пароли не совпадают', sameAs(passwordConfirmation)),
  },
  controlQuestionId: {
    required: helpers.withMessage('Контрольный вопрос не может быть пустым', required),
  },
  controlAnswer: {
    requiredIf: helpers.withMessage(
      'Ответ на контрольный вопрос не может быть пустым',
      requiredIf(() => {
        return !user.value?.controlAnswerHash && user.value?.controlQuestionId !== userOpts.value.controlQuestionId
      }),
    ),
  },
}))

const visibleCardIssuePointSelect = computed(() => {
  const selectedRole = roles.value.find(role => role.id === user.value?.roleId)
  return selectedRole && selectedRole.type === RoleType.OPERATOR
})

const validator = useVuelidate<UpdateUserOpts>(rules, userOpts)

const submit = () => {
  handleError(async () => {
    const valid = await validator.value.$validate()
    if (!valid || !user.value) return

    const opts = pickBy(userOpts.value, (val, key) => {
      if (!val) return false
      return user.value?.[key as keyof typeof user.value] !== val
    })

    if (isEmpty(opts)) return

    await props.usersService.update(createCtx(), user.value?.id, opts)
    callSuccessToast('Ваши данные обновлены')
    router?.back()
  }, loading)
}

const getErrorMessages = (errors: ErrorObject[]) => {
  return errors.map((e: ErrorObject) => e.$message).join()
}

watch(
  () => userOpts.value.municipalEntityId,
  value => {
    if (user.value?.municipalEntityId !== value) {
      userOpts.value.cardIssuePointId = undefined
    }
  },
)

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), null, {
            default: _withCtx(() => [
              (!loadingUser.value)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(user.value ? _unref(userGetFullname)(user.value) : 'Профиль'), 1))
                : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                    key: 1,
                    type: "heading@1",
                    class: "bg-transparent",
                    width: "450"
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
        default: _withCtx(() => [
          (!loadingUser.value)
            ? (_openBlock(), _createBlock(_component_v_form, {
                key: 0,
                onSubmit: _withModifiers(submit, ["prevent"]),
                disabled: loading.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            label: "Роль",
                            "model-value": user.value?.roleId,
                            items: roles.value,
                            loading: loadingRoles.value,
                            "item-title": "name",
                            "item-value": "id",
                            "no-data-text": "Нет данных",
                            readonly: "",
                            disabled: loading.value
                          }, null, 8, ["model-value", "items", "loading", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            "model-value": user.value?.email,
                            label: "Email",
                            type: "email",
                            readonly: ""
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(userOpts).surname,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userOpts).surname) = $event)),
                            label: "Фамилия",
                            "error-messages": getErrorMessages(_unref(validator).surname.$errors)
                          }, null, 8, ["modelValue", "error-messages"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(userOpts).name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(userOpts).name) = $event)),
                            label: "Имя",
                            "error-messages": getErrorMessages(_unref(validator).name.$errors)
                          }, null, 8, ["modelValue", "error-messages"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(userOpts).patronymic,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userOpts).patronymic) = $event)),
                            label: "Отчество"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(VPhoneField), {
                            phone: _unref(userOpts).phone,
                            "onUpdate:phone": _cache[3] || (_cache[3] = ($event: any) => ((_unref(userOpts).phone) = $event)),
                            label: "Телефон",
                            "error-messages": getErrorMessages(_unref(validator).phone.$errors)
                          }, null, 8, ["phone", "error-messages"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(VPasswordField), {
                            modelValue: _unref(userOpts).password,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(userOpts).password) = $event)),
                            label: "Пароль",
                            "error-messages": getErrorMessages(_unref(validator).password.$errors)
                          }, null, 8, ["modelValue", "error-messages"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(VPasswordField), {
                            modelValue: _unref(passwordConfirmation),
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(passwordConfirmation) ? (passwordConfirmation).value = $event : null)),
                            label: "Подтвердите пароль",
                            "error-messages": getErrorMessages(_unref(validator).password.$errors)
                          }, null, 8, ["modelValue", "error-messages"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            label: "Контрольный вопрос",
                            modelValue: _unref(userOpts).controlQuestionId,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(userOpts).controlQuestionId) = $event)),
                            items: controlQuestions.value,
                            loading: loadingControlQuestions.value,
                            "item-title": "question",
                            "item-value": "id",
                            "no-data-text": "Нет данных",
                            clearable: "",
                            "error-messages": getErrorMessages(_unref(validator).controlQuestionId.$errors)
                          }, null, 8, ["modelValue", "items", "loading", "error-messages"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(userOpts).controlAnswer,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(userOpts).controlAnswer) = $event)),
                            label: "Ответ на контрольный вопрос",
                            "error-messages": getErrorMessages(_unref(validator).controlAnswer.$errors)
                          }, null, 8, ["modelValue", "error-messages"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: visibleCardIssuePointSelect.value ? 6 : 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(VMunicipalEntitiesSelect), {
                            modelValue: _unref(userOpts).municipalEntityId,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(userOpts).municipalEntityId) = $event)),
                            "municipal-entities-service": _ctx.municipalEntitiesService,
                            disabled: loading.value,
                            readonly: ""
                          }, null, 8, ["modelValue", "municipal-entities-service", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["md"]),
                      (visibleCardIssuePointSelect.value)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(VCardIssuePointSelect), {
                                modelValue: _unref(userOpts).cardIssuePointId,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(userOpts).cardIssuePointId) = $event)),
                                "card-issue-points-service": _ctx.cardIssuePointsService,
                                "municipal-entities-service": _ctx.municipalEntitiesService,
                                "additional-filter-data": { municipalEntityId: _unref(userOpts).municipalEntityId },
                                disabled: loading.value
                              }, null, 8, ["modelValue", "card-issue-points-service", "municipal-entities-service", "additional-filter-data", "disabled"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { justify: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            type: "submit",
                            loading: loading.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Сохранить ")
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSubmit", "disabled"]))
            : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                key: 1,
                type: "heading@8, actions"
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})